export default "__VITE_ASSET__72028ee3__"